import { faqs } from '@/mocks/data';

export default function FAQSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于亚洲一级日本内容导航平台的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform duration-200">
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}